import { useEffect } from "react";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import { useQuery } from "@tanstack/react-query";
import { getAllPerms } from "@/features/mod-perms/api/get-all-mod-perms";
import { useAccount } from "wagmi";
import { ModPermsQueryKeys } from "@/types/modular-permissions.types";

const useDelegations = () => {
  const account = useAccount();

  const {
    setDelegatePermissions,
    setReceivedPermissions,
    setMirroredDelegatePermissions,
    setMirroredReceivedPermissions,
  } = useModularPermissionsStore();

  const fetchControls = useQuery({
    queryKey: [
      ModPermsQueryKeys.ModularPermissions,
      account.address,
      account.chainId,
    ],
    queryFn: () => getAllPerms(account.chainId, account.address),
    enabled: !!account.address,
  });

  useEffect(() => {
    if (fetchControls.data) {
      setDelegatePermissions(fetchControls.data.asVault);
      setReceivedPermissions(fetchControls.data.asDelegate);
      setMirroredDelegatePermissions(fetchControls.data.asVaultMirrored);
      setMirroredReceivedPermissions(fetchControls.data.asDelegateMirrored);
    }
  }, [
    fetchControls.data,
    setDelegatePermissions,
    setMirroredDelegatePermissions,
    setMirroredReceivedPermissions,
    setReceivedPermissions,
  ]);

  return fetchControls;
};

export default useDelegations;
